(function (H) {
    function deferRender (proceed) {
        
        var series = this, 
            $renderTo = $(this.chart.container.parentNode);

        if($('body').hasClass('is-mobile') || this.chart.plotWidth < 300) {
            // If it seems like we're on mobile, don't defer rendering
            proceed.call(series);
            hideLastColumnGridline();
        } else if($('#sharable-dashboard-editor').length > 0) {
            // Don't do this in the editor for now.  It's acting funny (e.g., won't draw until the 3rd time you click on a slide thumbnail
            proceed.call(series);
        } else if($renderTo.hasClass('graph-container__defer-animation') === false || series.options.animation === null || series.options.animation == false) {
            // Animations are disabled or unavailable for this graph type
            proceed.call(series);
        } else  {
            // There are animations, so wait to be told to draw
            $($renderTo).on('sdrDraw', function () {
                proceed.call(series);
                hideLastColumnGridline();
            });
        }
    };
    
    H.wrap(H.Series.prototype, 'render', deferRender);
    
}(Highcharts));